import React, { useState, useEffect } from 'react';
import axios from 'axios';
import InputField from '../components/InputField'; // Import the component

const CompanyMaster = () => {
  const [companies, setCompanies] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    gstNo: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    pin: '',
    mobile: '',
    phone: '',
    id: null,
  });
  const [formError, setFormError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Fetch all companies
  const fetchCompanies = async () => {
    try {
        const response = await axios.get('https://astrovidhya.in/api/companies');
        setCompanies(response.data); // Ensure this updates the state correctly
    } catch (error) {
        console.error('Error fetching companies:', error);
    }
};


  useEffect(() => {
    fetchCompanies();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = formData.id
        ? `https://astrovidhya.in/api/companies/${formData.id}` // Update company
        : 'https://astrovidhya.in/api/companies'; // Create company
    const method = formData.id ? 'PUT' : 'POST';

    try {
        const response = await axios({
            method,
            url,
            headers: { 'Content-Type': 'application/json' },
            data: formData,
        });

        // Update local state
        if (method === 'POST') {
            setCompanies([...companies, response.data.company]); // Add new company
        } else {
            setCompanies(companies.map((company) =>
                company._id === response.data.company._id ? response.data.company : company
            ));
        }

        setSuccessMessage('Company saved successfully!');
        resetForm();
    } catch (error) {
        console.error('Error saving company:', error.response?.data || error.message);
        setFormError('Failed to save company.');
    }
};


  const handleEdit = (company) => {
    setFormData({
      ...company,
      id: company._id,
    });
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this company?')) {
        try {
            await axios.delete(`https://astrovidhya.in/api/companies/${id}`, {
                headers: { 'Content-Type': 'application/json' },
            });

            // Update local state
            setCompanies(companies.filter((company) => company._id !== id));
            setSuccessMessage('Company deleted successfully!');
        } catch (error) {
            console.error('Error deleting company:', error.response?.data || error.message);
            setFormError('Failed to delete company.');
        }
    }
};

  const resetForm = () => {
    setFormData({
      name: '',
      gstNo: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      pin: '',
      mobile: '',
      phone: '',
      id: null,
    });
    setFormError('');
  };

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Company Master</h2>

      {/* Form Section */}
      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Company Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            maxLength={40} // Maximum of 40 characters allowed
            required
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">GST Number</label>
          <input
            type="text"
            name="gstNo"
            value={formData.gstNo}
            onChange={handleChange}
            maxLength={40} // Maximum of 40 characters allowed
            required
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Address 1</label>
          <input
            type="text"
            name="address1"
            value={formData.address1}
            onChange={handleChange}
            maxLength={40} // Maximum of 40 characters allowed
            required
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Address 2</label>
          <input
            type="text"
            name="address2"
            value={formData.address2}
            maxLength={40} // Maximum of 40 characters allowed
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight"
          />
        </div>
        <div className="flex mb-4">
          <div className="w-1/3 pr-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">City</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              maxLength={40} // Maximum of 40 characters allowed
              required
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight"
            />
          </div>
          <div className="w-1/3 px-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">State</label>
            <input
              type="text"
              name="state"
              value={formData.state}
              onChange={handleChange}
              maxLength={40} // Maximum of 40 characters allowed
              required
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight"
            />
          </div>
          <div className="w-1/3 pl-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">Pin Code</label>
            <input
              type="text"
              name="pin"
              value={formData.pin}
              onChange={handleChange}
              maxLength={6} // Exactly 6 digits required
              required
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight"
            />
          </div>
        </div>
        <div className="flex mb-4">
          <div className="w-1/2 pr-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">Mobile</label>
            <input
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              maxLength={10} // Exactly 10 digits required
              required
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight"
            />
          </div>
          <div className="w-1/2 pl-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">Phone</label>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              maxLength={15} // Exactly 15 digits required
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight"
            />
          </div>
        </div>
        {formError && <p className="text-red-500 text-xs italic">{formError}</p>}
        {successMessage && <p className="text-green-500 text-xs italic">{successMessage}</p>}
        <div className="flex items-center justify-between">
  <button
    type="submit"
    className="bg-[#03C9D7] hover:bg-[#02A5B3] text-white font-bold py-2 px-32 rounded"
  >
    Save
  </button>


          <button
            type="button"
            onClick={resetForm}
            className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-32 rounded"
          >
            Reset
          </button>
        </div>
      </form>

      {/* List Section */}
      <h3 className="text-xl font-bold mb-4">Company List</h3>
      <table className="min-w-full bg-white border border-gray-300">
        <thead>
          <tr>
            <th className="py-2 px-4 border-b">Company Name</th>
            <th className="py-2 px-4 border-b">GST Number</th>
            <th className="py-2 px-4 border-b">Address 1</th>
            <th className="py-2 px-4 border-b">City</th>
            <th className="py-2 px-4 border-b">State</th>
            <th className="py-2 px-4 border-b">Pin Code</th>
            <th className="py-2 px-4 border-b">Mobile</th>
            <th className="py-2 px-4 border-b">Actions</th>
          </tr>
        </thead>
        <tbody>
          {companies.map((company) => (
            <tr key={company._id}>
              <td className="py-2 px-4 border-b">{company.name}</td>
              <td className="py-2 px-4 border-b">{company.gstNo}</td>
              <td className="py-2 px-4 border-b">{company.address1}</td>
              <td className="py-2 px-4 border-b">{company.city}</td>
              <td className="py-2 px-4 border-b">{company.state}</td>
              <td className="py-2 px-4 border-b">{company.pin}</td>
              <td className="py-2 px-4 border-b">{company.mobile}</td>
              <td className="py-2 px-4 border-b">
                <button
                  onClick={() => handleEdit(company)}
                  className="bg-yellow-500 text-white px-2 py-1 rounded mr-2 w-1/3"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(company._id)}
                  className="bg-red-500 text-white px-2 py-1 rounded w-1/3"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {companies.length === 0 && <p className="text-gray-500 mt-4">No companies found.</p>}
    </div>
  );
};

export default CompanyMaster;
